module.exports = __webpack_public_path__ + "static/media/footer_youtube.4c62d0cd.svg";